import { Icon, IconProps } from "../";

export const MccmDuoNotebookOpenIcon = (props: Omit<IconProps, "fill">) => {
  return (
    <Icon {...props}>
      <path
        d="M11.9863 5.85867V18.6614C14.7774 17.9641 18.5931 17.9527 21.3842 18.6385V5.84724C20.2065 5.50431 18.5813 5.16138 16.697 5.16138C14.8127 5.16138 13.1287 5.51574 11.9863 5.85867Z"
        fill="white"
      />
      <path
        d="M2.61816 5.8379V18.6509C5.3857 17.9639 9.18959 17.9753 11.9807 18.6509V5.8379C10.8266 5.49439 9.21315 5.15088 7.31709 5.15088C5.42103 5.15088 3.77229 5.49439 2.61816 5.8379Z"
        fill="#F7EE4D"
      />
      <path
        d="M21.5189 5.31363C20.434 4.94854 18.7247 4.5 16.6878 4.5C14.651 4.5 13.1157 4.89638 12 5.26147C10.915 4.90682 9.26714 4.5 7.31218 4.5C5.35722 4.5 3.54555 4.93811 2.42989 5.32406C2.174 5.40751 2 5.64743 2 5.91864V18.8741C2 19.2914 2.47083 19.6043 2.85977 19.4687C5.31627 18.6342 9.29785 18.6342 11.7543 19.4687C11.8158 19.4896 11.9284 19.5 12 19.5C12.0409 19.5 12.0716 19.4896 12.1024 19.4791C12.1535 19.4791 12.1945 19.4791 12.2457 19.4687C14.7021 18.6342 18.6837 18.6342 21.1402 19.4687C21.2016 19.4896 21.3142 19.5 21.3859 19.5C21.7236 19.5 22 19.2184 22 18.8741V5.91864C22 5.64743 21.7851 5.39708 21.5292 5.31363H21.5189ZM20.7615 18.0501C18.3357 17.4138 15.0194 17.4346 12.5937 18.0709V6.38804C13.5865 6.0751 15.0092 5.75174 16.6878 5.75174C18.3664 5.75174 19.7277 6.06467 20.7615 6.37761V18.0501ZM11.3654 18.0605C8.93961 17.4346 5.64381 17.4242 3.22825 18.0605V6.37761C4.22109 6.06467 5.65404 5.75174 7.31218 5.75174C8.97032 5.75174 10.3623 6.06467 11.3654 6.37761V18.0605Z"
        fill="#333333"
      />
    </Icon>
  );
};
